import React from 'react';
import {Box, styled} from '@mui/material';
import {AssetProps} from '@contentlab/types/projectProps';
import Skeleton from '@/components/skeleton';

interface LoadingAssetPreviewProps {
  asset: AssetProps;
}

const ThumbnailContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  position: 'relative',
  padding: '16px',
  boxSizing: 'border-box',
}));

const ImageWrapper = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',
  minHeight: 0,
}));

const ThumbnailImage = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: '100%',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  borderRadius: '8px',
  display: 'block',
}));

function LoadingAssetPreview({asset}: LoadingAssetPreviewProps) {
  if (!asset.thumbnailUrl) {
    return null;
  }

  return (
    <ThumbnailContainer>
      <ImageWrapper>
        <ThumbnailImage src={asset.thumbnailUrl} alt="" />
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{
            'position': 'absolute',
            'top': 0,
            'left': 0,
            'borderRadius': '8px',
            '&.MuiSkeleton-root': {
              background: 'transparent',
            },
            '&.MuiSkeleton-wave::after': {
              background:
                'linear-gradient(to left, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0) 60%)',
            },
          }}
        />
      </ImageWrapper>
    </ThumbnailContainer>
  );
}

export default LoadingAssetPreview;
